/**
 * Shared react-hook-form defaults for consistent validation UX:
 * - validate on change so submit can stay disabled until the form is valid
 * - single helper for primary actions
 */
export const STANDARD_FORM_OPTIONS = {
  mode: 'onChange',
  reValidateMode: 'onChange',
}

/**
 * @param {{ isValid: boolean, isSubmitting?: boolean, extraDisabled?: boolean }} params
 */
export function isSubmitDisabled({ isValid, isSubmitting = false, extraDisabled = false }) {
  return extraDisabled || isSubmitting || !isValid
}
